module.exports = __webpack_public_path__ + "img/manage.dd7d98e8.png";